<template>
  <b-container>
    <b-overlay
      :show="loading"
      rounded
      opacity="0.6"
      spinner-large
      spinner-variant="info"
      class="d-inline-block w-100"
      @hidden="!loading"
    >
      <b-row class="m-2">
        <b-col md="12" class="p-2">
          <b-card class="shadow-sm w-100 text-center" title="دسترسی سریع">
            <b-button variant="info" class="m-1" @click="$router.push({ name: 'CreateDocument' })">ایجاد مستند</b-button>
            <b-button variant="info" class="m-1" @click="$router.push({ name: 'CreateKeyword' })">ایجاد کلیدواژه</b-button>
            <b-button variant="info" class="m-1" @click="$router.push({ name: 'CreateReference' })">ایجاد منبع</b-button>
            <b-button variant="info" class="m-1" @click="$router.push({ name: 'CreateTopic' })">ایجاد سرفصل</b-button>
          </b-card>
        </b-col>
      </b-row>
      <b-row class="mx-2 mb-2">
        <b-col md="4" class="p-2">
          <b-card class="shadow-sm text-center text-secondary" @click="$router.push({ name: 'keywordsTable' })">
            <h2>کلیدواژه ها</h2>
            <h3 class="mt-1"><b-badge pill variant="secondary">{{ totals.keyword }}</b-badge></h3>
          </b-card>
        </b-col>
        <b-col md="4" class="p-2">
          <b-card class="shadow-sm text-center text-secondary" @click="$router.push({ name: 'TopicsTable' })">
            <h2>سرفصل ها</h2>
            <h3 class="mt-1"><b-badge pill variant="secondary">{{ totals.topic }}</b-badge></h3>
          </b-card>
        </b-col>
        <b-col md="4" class="p-2">
          <b-card class="shadow-sm text-center text-info">
            <h1>آمار ها</h1>
            <p>تعداد کل موجودیت ها</p>
          </b-card>
        </b-col>
        <b-col md="4" class="p-2">
          <b-card class="shadow-sm text-center text-secondary" @click="$router.push({ name: 'UsersTable' })">
            <h2>کاربران</h2>
            <h3 class="mt-1"><b-badge pill variant="secondary">{{ totals.user }}</b-badge></h3>
          </b-card>
        </b-col>
        <b-col md="4" class="p-2">
          <b-card class="shadow-sm text-center text-secondary" @click="$router.push({ name: 'ReferencesTable' })">
            <h2>منابع</h2>
            <h3 class="mt-1"><b-badge pill variant="secondary">{{ totals.reference }}</b-badge></h3>
          </b-card>
        </b-col>
        <b-col md="4" class="p-2">
          <b-card class="shadow-sm text-center text-secondary" @click="$router.push({ name: 'DocumentsTable' })">
            <h2>مستندات</h2>
            <h3 class="mt-1"><b-badge pill variant="secondary">{{ totals.document }}</b-badge></h3>
          </b-card>
        </b-col>
      </b-row>
    </b-overlay>
  </b-container>
</template>
<script>
export default {
  name: 'Dashboard',
  data: () => ({
    loading: false,
    totals: {
      keyword: null,
      topic: null,
      user: null,
      reference: null,
      document: null
    }
  }),
  created() {
    this.fetchPanelDashPageData()
  },
  methods: {
    fetchPanelDashPageData() {
      this.loading = true
      this.$axios.get('/pages/panel-dashboard').then((response) => {
        const body = response.data

        this.totals = body.data.totals
      }).catch(err => {
        this.$bvToast.toast(err.text, { variant: 'danger', title: 'خطا' })
      }).finally(() => {
        this.loading = false
      })
    },
  }
}
</script>